import { render, staticRenderFns } from "./GGFilter.vue?vue&type=template&id=3ca8a690&"
import script from "./GGFilter.vue?vue&type=script&lang=js&"
export * from "./GGFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca8a690')) {
      api.createRecord('3ca8a690', component.options)
    } else {
      api.reload('3ca8a690', component.options)
    }
    module.hot.accept("./GGFilter.vue?vue&type=template&id=3ca8a690&", function () {
      api.rerender('3ca8a690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Elements/GGFilter.vue"
export default component.exports